//External Libraries
import React, { useEffect, lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";

// Components (eager)
import NavBar from "../components/navbar";
import HeroSection from "../components/hero-section";

// Components (lazy)
const TrustedBy = lazy(() => import("../components/trustedby-cargopro"));
const AboutUs = lazy(() => import("../components/about-cargopro"));
const WhyChooseCargoPro = lazy(() =>
  import("../components/why-choose-cargopro")
);
const SolutionsSection = lazy(() => import("../components/solutions"));
const StakeholdersOrbit = lazy(() =>
  import("../components/stakeholders-orbit")
);
const CargoProSteps = lazy(() =>
  import("../components/cargopro-onboarding-steps")
);
// const Reviews = lazy(() => import("../components/reviews"));
const CargoProBookDemo = lazy(() => import("../components/cargopro-book-demo"));
const Footer = lazy(() => import("../components/footer"));
const ROICalculator = lazy(() => import("../components/roi-calculator"));
const Home = () => {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "auto" }); // jump instantly
      }
    }
  }, []);
  return (
    <>
      <Helmet>
        <title>
          CargoPro | Best AI-Powered Transport Management System (TMS) for
          Manufacturers in India
        </title>
        <link rel="icon" type="image/webp" href="/CargoProLogo.webp" />
        <meta
          name="description"
          content="CargoPro is India’s leading AI-powered Transport Management System for manufacturers. Automate gate, yard, weighbridge & tracking. Reduce TAT, detention & logistics cost. Book a demo."
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/CargoProLogo.webp"
        />
        <link
          rel="preload"
          as="image"
          href="/images/CargoProIndexPage/cargopro-putting-your-logistics.webp"
        />
      </Helmet>
      <div className="overflow-x-hidden">
        <NavBar />
        <main id="main-content">
          <HeroSection
            heading={
              <>
                Putting Your Logistics
                <br />
                on Autopilot
              </>
            }
            content={
              <>
                AI-Based SaaS Platform Driving Operational
                <br />
                Efficiency, Automation, and Transparency across
                <br />
                Logistics Operations
              </>
            }
            image="/images/CargoProIndexPage/cargopro-putting-your-logistics.webp"
            buttonLabel="Schedule Demo"
          />
          <Suspense
            fallback={
              <div className="sr-only" role="status" aria-live="polite">
                Loading…
              </div>
            }
          >
            <TrustedBy />
            <div id="roi"></div>
            <ROICalculator />
            <AboutUs />
            <div id="whyChooseCargoPro">
              <WhyChooseCargoPro />
            </div>
            <SolutionsSection />
            <StakeholdersOrbit />
            <CargoProSteps />
            {/* <Reviews /> */}
            <CargoProBookDemo
              heading={
                <>
                  Ready to Simplify Your Logistics
                  <br /> Operations?
                </>
              }
            />
            <Footer />
          </Suspense>
        </main>
      </div>

      {/* Add other components as needed */}
    </>
  );
};

export default Home;
